module.exports = __webpack_public_path__ + "static/media/in.dc3603fe.PNG";